import { Redirect, Route, Switch } from 'react-router-dom';
import { useAuth } from '../providers';

import Activate from './Activate';
import Announcements from './Announcements';
import CurrentlyLive from './CurrentlyLive';
import Dashboard from './Dashboard';
import Help from './Help';
import HomePage from './HomePage';
import KnowledgeBase from './KnowledgeBase';
import Login from './Login';

export default function OriginalRouter() {
    const ProtectedRoute = ({ children, ...rest }) => {
        const { authenticated } = useAuth()

        return (
            <Route
                {...rest}
                render={({ location }) =>
                    authenticated ? children : (
                        <Redirect
                            to={{
                                pathname: '/login',
                                state: { from: location },
                            }}
                        />
                    )
                }
            />
        )
    }

    return (
        <Switch>
            <ProtectedRoute path='/dashboard'>
                <Dashboard />
            </ProtectedRoute>
            <Route path='/activate/:token' component={Activate} />
            <Route path='/announcements' component={Announcements} />
            <Route path='/live' component={CurrentlyLive} />
            <Route path='/help/:streamer' component={Help} />
            <Route path='/help' component={Help} />
            <Route path='/login' component={Login} />
            <Route path='/support' component={KnowledgeBase} />
            <Route path='/' exact component={HomePage} />
            <Redirect to='/' />
        </Switch>
    )
}
